import GameAuthService from './GameAuthService.service.js'
import WebAuthService from './WebAuthService.service.js'

export {
  GameAuthService,
  WebAuthService,
}
